import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Col, Form, Form as FormInitial, message, Row, Space } from "antd";
import FormItem from "antd/lib/form/FormItem";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { ButtonItem, InputItem, ModalItem } from "../../../../Components/Items";

class ModalVerRegistroProceso extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    pdfUrl: null,
    error: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && this.props.visible !== prevProps.visible) {
      this.consultarPdf();
    }
  }

  componentWillUnmount() {
    this.revocarPdfUrl();
  }

  revocarPdfUrl() {
    if (this.state.pdfUrl) {
      URL.revokeObjectURL(this.state.pdfUrl);
    }
  }

  async consultarPdf() {
    this.revocarPdfUrl();
    this.setState({ loading: true, pdfUrl: null, error: null });

    try {
      const res = await axios.post(
        "programa/verPdfRegistroProceso",
        { empresaId: this.props.empresaId, registroId: this.props.registroId },
        { headers: this.props.headersToken, responseType: "arraybuffer" }
      );

      const blob = new Blob([res.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      this.setState({ loading: false, pdfUrl: url });
    } catch (err) {
      console.error(err);
      this.setState({ loading: false, error: "No se pudo cargar el PDF del registro." });
    }
  }

  cerrarModal() {
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
    this.revocarPdfUrl();
    this.setState({ pdfUrl: null, error: null });
    this.props.onCancel();
  }

  onFinish = async (values) => {
    if (!values?.correosEnvio?.length) {
      message.info("Proporcione al menos un correo de envío");
      return;
    }

    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "programa/enviarPdfRegistroProcesoCorreo",
        {
          empresaId: this.props.empresaId,
          registroId: this.props.registroId,
          correosEnvio: values.correosEnvio,
        },
        { headers: this.props.headersToken }
      );

      if (res.data.succes === 2) {
        message.success("Registro enviado");
        this.cerrarModal();
      } else if (res.data.succes === 1) {
        message.error(res.data.message || "No se pudo enviar a los correos indicados");
      } else {
        message.error(res.data.message || "Sucedió un error y no se pudo enviar");
      }
    } catch (err) {
      console.error(err);
      message.error("Ocurrió un error al enviar el correo. Intenta nuevamente.");
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    return (
      <ModalItem
        title="Ver Registro de Calidad"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModal.bind(this)}
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="verRegistroProcesoPdf"
          layout
          width={700}
          onFinish={this.onFinish}
        >
          <FormInitial.List name="correosEnvio" initialValue={[{ correo: "" }]}>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ name }, arrayKey) => (
                  <Row key={name}>
                    <Col span={22}>
                      <FormItem
                        name={[name, "correo"]}
                        fieldKey={[arrayKey, "correo"]}
                        label="Correo"
                        required
                        margin
                        email
                        pattern
                      >
                        <InputItem style={{ width: "100%" }} placeholder="Correo" />
                      </FormItem>
                    </Col>
                    <Col span={2}>
                      <div style={{ textAlign: "center" }}>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </div>
                    </Col>
                  </Row>
                ))}
                {fields.length < 5 ? (
                  <div style={{ textAlign: "center", marginTop: "5px" }}>
                    <ButtonItem type="primary" onClick={() => add()} icon={<PlusOutlined />}>
                      Agregar
                    </ButtonItem>
                  </div>
                ) : null}
              </>
            )}
          </FormInitial.List>
          <div style={{ display: "flex", justifyContent: "right", marginTop: 20, marginBottom: 10 }}>
            <Space>
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Mandar Correo
              </ButtonItem>
              <ButtonItem
                type="primary"
                danger
                onClick={this.cerrarModal.bind(this)}
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Cancelar
              </ButtonItem>
            </Space>
          </div>
        </Form>
        {this.state.error ? (
          <div style={{ color: "red", textAlign: "center" }}>{this.state.error}</div>
        ) : this.state.pdfUrl ? (
          <iframe
            title="Registro de Calidad PDF"
            src={this.state.pdfUrl}
            style={{ width: "100%", height: "100vh", border: 0 }}
          />
        ) : null}
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalVerRegistroProceso);
